<template>
 <div class="com-wap">
   <div class="d-flex">
      <a-button
        type="primary"
        @click="onRelevance"
        >{{$t('page_andon_associated_call_type')}}</a-button
      >
    </div>
    <div class="table-wrap" ref="tableWrap">
    <ml-table
    :columns="columns"
    :data-source="list"
    :loading="loading"
    :scroll="{y:tableHeight}"
    >
      <template #action="record">
        <a-popconfirm
          :title="$t('delete_tips')+'?'"
          :okText="$t('ok')"
          :cancelText="$t('cancel')"
          @confirm="remove(record.id)"
        >
        <a
          href="javascript:;"
          style="color: var(--color-red)"
          >{{ $t("delete") || "删除" }}</a
        >
        </a-popconfirm>
      </template>
    </ml-table>
    </div>
    <relevanceCallOutModal :deviceTypeId="deviceTypeId"  v-model="relevanceCallOutModalShow" @close="relevanceCallOutModalShow=false"
    @ok="relevanceSuccess"
    />
</div>
</template>
<script>
/* eslint-disable @typescript-eslint/no-use-before-define */
import relevanceCallOutModal from './relevanceCallOutModal.vue';
import { DeviceTypeAndonTypeServiceProxy} from '@/service-proxies/app-v2/tpm.service-proxies'
const deviceTypeAndonTypeServiceProxy = new DeviceTypeAndonTypeServiceProxy();
export default{
  props:{
    deviceTypeId:{

    }
  },
  components:{
    relevanceCallOutModal
  },
  created(){
    this.getList();
  },
  mounted(){
    this.$nextTick(() => {
      if(this.$refs.tableWrap){
        this.tableHeight = this.$refs.tableWrap.clientHeight - 34;
      }
    })

  },
  watch:{
    deviceTypeId:function(){
      this.getList();
    }
  },
  methods:{
    // 关联呼叫类型
    onRelevance(){
      this.relevanceCallOutModalShow = true;
    },
    // 导出
    onExport(){
      // export
    },
    // 删除
    remove(id){
      const _this = this;
      /*this.$confirm({
        content: _this.$t('delete_tips')+'?',
        onOk() {
          deviceTypeAndonTypeServiceProxy.deleteDeviceTypeAndonType(id).then(() => {
            _this.$message.success(_this.$t('delete_success'));
            _this.getList();
          })
        },
        onCancel() {

        },
      });*/
      deviceTypeAndonTypeServiceProxy.deleteDeviceTypeAndonType(id).then(() => {
        _this.$message.success(_this.$t('delete_success'));
        _this.getList();
      })
    },
    onSearch(){

    },
    onSelectRow(){

    },
    getList(){
      this.loading = true;
      deviceTypeAndonTypeServiceProxy.getDeviceTypeAndonTypePage(1,this.deviceTypeId,-1).then(res => {
        this.loading = false;
        this.list = res.records || [];
      }).catch(() => {
        this.loading = false;
      })
    },
    relevanceSuccess(){
      this.relevanceCallOutModalShow = false;
      this.getList();
    }

  },
  data(){
    return {
      relevanceCallOutModalShow:false,
      selectedRowKeys:[],
      tableHeight:200,
      columns:[{
            key: "action",
            title:this.$t('actions'),           //"操作",
            width:80,
            scopedSlots: { customRender: "action" },
          },
          {
            dataIndex: "andonTypeCode",
            title: this.$t('page_andon_call_type_code'),           //"呼叫类型编码",
          },
          {
            dataIndex: "andonTypeName",
            title:this.$t('page_andon_call_type_name'),  // "呼叫类型名称",
          },
          {
            dataIndex: "employeeNames",
            title:this.$t('page_andon_call_processing_personnel'),  // "处理人员",
          },
          {
            dataIndex: "remark",
            title: this.$t('remark'),  //"备注",
          },],
          list:[],
          loading:false
    }
  }
}
</script>
<style lang="less" scoped>
.com-wap{
  height: 100%;
  width: 100%;
  padding: 8px 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.table-wrap{
  margin-top:10px;
  flex:1;
  overflow: auto;
}
</style>
